import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgWave = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMinYMin"
    viewBox="0 0 23 5"
    {...props}
  >
    <path
      fill="none"
      stroke="#17181A"
      d="M0 4c1.199-.504 2.167-1.504 2.906-3 1.64 2.63 5.904 3.232 7.997 0 2.34 2.18 6.018 3.684 8.102 0C19.99 2.077 21.39 3.343 23 3.246"
    />
  </svg>
);
const Memo = memo(SvgWave);
export default Memo;
